import { until } from "@vueuse/core";

import { storeToRefs } from "pinia";
import { watch } from "vue";

import { useDomainTermsStore } from "@/stores/domain-terms-store";

import { DomainTermEntity } from ".";
import { BaseLinkedEntitiesManager } from "../mystekz-linked-entities/manager";

/**
 * Manages the domain terms and replaces matching links with linked-entity nodes.
 */
export class DomainTermsManager extends BaseLinkedEntitiesManager<DomainTermEntity> {
    nodeType = "domain_term" as const;

    constructor(baseUrl: string) {
        const { domainTerms, isLoading } = storeToRefs(useDomainTermsStore());

        super(baseUrl);
        this.events = new EventTarget();
        this.ready = until(isLoading).not.toBeTruthy();

        watch(
            domainTerms,
            async (newValue) => {
                if (newValue) {
                    this.setEntities(newValue);
                }
            },
            { immediate: true, deep: true }
        );
    }
}
